///jacques-andre-editeur\proshop-v2\frontend\src\components\BooksCollectionCard.jsx
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useGetBooksByBooksCollectionQuery, useGetThreeRandomBooksByBooksCollectionQuery } from '../slices/booksApiSlice';

const BooksCollectionCard = ({ booksCollection }) => {
  const { data: randomBooks } = useGetThreeRandomBooksByBooksCollectionQuery(booksCollection._id);
  const { data: allBooks } = useGetBooksByBooksCollectionQuery(booksCollection._id);
if (typeof booksCollection?.intention === 'string') {
  console.log(booksCollection?.name + ' : ' + booksCollection?.intention + ' , ' + booksCollection.intention.trim().length);
}
  return (
    <div className='booksCollectionCard'>
      <Link
        to={`/collection/${booksCollection.slug}`}
        className='booksCollection-card-link'
        title={booksCollection.name}
      >
        <div className='randomCoversContainer'>
          {randomBooks?.map((book, index) => (
            <div key={index} className={`randomCoverContainer${index}`}>
              <img src={book?.cover} alt={book?.title} className='randomCover' />
            </div>
          ))}
        </div>
        <div className='booksCollection-title'>{booksCollection?.name}</div>
        {typeof booksCollection?.intention === 'string' && booksCollection.intention.trim().length > 0 && booksCollection.intention !== '<p><br></p>' && (<>
        <div className='booksCollection-bio'>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(booksCollection?.intention?.replace(/<[^>]+>/g, '')?.slice(0, 200) + '...'),
            }}
          />
        </div>
        <p className='enSavoirPlus'>En savoir plus</p></>)}
      </Link>

        {allBooks?.length > 0 && (
          <p className='booksCollectionAllBooks'>
            <b>À lire dans la collection {booksCollection?.name} :{' '}</b>
            {allBooks?.map((book, index) => (
              <span key={book?._id}>
                <Link to={`/livre/${book?.slug}`}>{book?.title}</Link>
                {index < allBooks?.length - 1 && ', '}
              </span>
            ))}
          </p>
        )}
    </div>
  );
};

export default BooksCollectionCard;
